(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-address-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-address-country-select]').forEach(function (countrySelect) {
      var form = countrySelect.closest('form');
      if (!form) return;

      var provinceSelect = form.querySelector('[data-address-province-select]');
      var provinceWrap = form.querySelector('[data-address-province-wrap]');
      if (!provinceSelect) return;

      new Shopify.CountryProvinceSelector(countrySelect.id, provinceSelect.id, {
        hideElement: provinceWrap ? provinceWrap.id : null,
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    var THRESHOLD = window.innerHeight;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ticking = false;

    function updateVisibility() {
      var visible = window.scrollY > THRESHOLD;
      button.hidden = false;
      button.classList.toggle('is-visible', visible);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }

    if (document.documentElement.scrollHeight <= window.innerHeight * 1.2) {
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateVisibility();

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["currency-converter"] && !Shopify.designMode) return;
  try {
    (function () {
    var CURRENCIES = [
      ['USD', 'US Dollar', 'US'], ['EUR', 'Euro', 'EU'], ['GBP', 'British Pound', 'GB'], ['CAD', 'Canadian Dollar', 'CA'],
      ['AFN', 'Afghan Afghani', 'AF'], ['ALL', 'Albanian Lek', 'AL'], ['DZD', 'Algerian Dinar', 'DZ'], ['AOA', 'Angolan Kwanza', 'AO'],
      ['ARS', 'Argentine Peso', 'AR'], ['AMD', 'Armenian Dram', 'AM'], ['AWG', 'Aruban Florin', 'AW'], ['AUD', 'Australian Dollar', 'AU'],
      ['BBD', 'Barbadian Dollar', 'BB'], ['AZN', 'Azerbaijani Manat', 'AZ'], ['BDT', 'Bangladeshi Taka', 'BD'], ['BSD', 'Bahamian Dollar', 'BS'],
      ['BHD', 'Bahraini Dinar', 'BH'], ['BIF', 'Burundian Franc', 'BI'], ['BYN', 'Belarusian Ruble', 'BY'], ['BYR', 'Belarusian Ruble (old)', 'BY'],
      ['BZD', 'Belize Dollar', 'BZ'], ['BMD', 'Bermudan Dollar', 'BM'], ['BTN', 'Bhutanese Ngultrum', 'BT'], ['BAM', 'Bosnia-Herzegovina Convertible Mark', 'BA'],
      ['BRL', 'Brazilian Real', 'BR'], ['BOB', 'Bolivian Boliviano', 'BO'], ['BWP', 'Botswanan Pula', 'BW'], ['BND', 'Brunei Dollar', 'BN'],
      ['BGN', 'Bulgarian Lev', 'BG'], ['MMK', 'Myanmar Kyat', 'MM'], ['KHR', 'Cambodian Riel', 'KH'], ['CVE', 'Cape Verdean Escudo', 'CV'],
      ['KYD', 'Cayman Islands Dollar', 'KY'], ['XAF', 'Central African CFA Franc', 'CM'], ['CLP', 'Chilean Peso', 'CL'], ['CNY', 'Chinese Yuan', 'CN'],
      ['COP', 'Colombian Peso', 'CO'], ['KMF', 'Comorian Franc', 'KM'], ['CDF', 'Congolese Franc', 'CD'], ['CRC', 'Costa Rican Colón', 'CR'],
      ['HRK', 'Croatian Kuna', 'HR'], ['CZK', 'Czech Koruna', 'CZ'], ['DKK', 'Danish Krone', 'DK'], ['DJF', 'Djiboutian Franc', 'DJ'],
      ['DOP', 'Dominican Peso', 'DO'], ['XCD', 'East Caribbean Dollar', 'AG'], ['EGP', 'Egyptian Pound', 'EG'], ['ETB', 'Ethiopian Birr', 'ET'],
      ['FKP', 'Falkland Islands Pound', 'FK'], ['XPF', 'CFP Franc', 'PF'], ['FJD', 'Fijian Dollar', 'FJ'], ['GIP', 'Gibraltar Pound', 'GI'],
      ['GMD', 'Gambian Dalasi', 'GM'], ['GHS', 'Ghanaian Cedi', 'GH'], ['GTQ', 'Guatemalan Quetzal', 'GT'], ['GYD', 'Guyanaese Dollar', 'GY'],
      ['GEL', 'Georgian Lari', 'GE'], ['GNF', 'Guinean Franc', 'GN'], ['HTG', 'Haitian Gourde', 'HT'], ['HNL', 'Honduran Lempira', 'HN'],
      ['HKD', 'Hong Kong Dollar', 'HK'], ['HUF', 'Hungarian Forint', 'HU'], ['ISK', 'Icelandic Króna', 'IS'], ['INR', 'Indian Rupee', 'IN'],
      ['IDR', 'Indonesian Rupiah', 'ID'], ['ILS', 'Israeli New Shekel', 'IL'], ['IRR', 'Iranian Rial', 'IR'], ['IQD', 'Iraqi Dinar', 'IQ'],
      ['JMD', 'Jamaican Dollar', 'JM'], ['JPY', 'Japanese Yen', 'JP'], ['JEP', 'Jersey Pound', 'JE'], ['JOD', 'Jordanian Dinar', 'JO'],
      ['KZT', 'Kazakhstani Tenge', 'KZ'], ['KES', 'Kenyan Shilling', 'KE'], ['KWD', 'Kuwaiti Dinar', 'KW'], ['KGS', 'Kyrgystani Som', 'KG'],
      ['LAK', 'Laotian Kip', 'LA'], ['LVL', 'Latvian Lats', 'LV'], ['LBP', 'Lebanese Pound', 'LB'], ['LSL', 'Lesotho Loti', 'LS'],
      ['LRD', 'Liberian Dollar', 'LR'], ['LYD', 'Libyan Dinar', 'LY'], ['MGA', 'Malagasy Ariary', 'MG'], ['MKD', 'Macedonian Denar', 'MK'],
      ['MOP', 'Macanese Pataca', 'MO'], ['MWK', 'Malawian Kwacha', 'MW'], ['MVR', 'Maldivian Rufiyaa', 'MV'], ['MXN', 'Mexican Peso', 'MX'],
      ['MYR', 'Malaysian Ringgit', 'MY'], ['MUR', 'Mauritian Rupee', 'MU'], ['MDL', 'Moldovan Leu', 'MD'], ['MAD', 'Moroccan Dirham', 'MA'],
      ['MNT', 'Mongolian Tugrik', 'MN'], ['MZN', 'Mozambican Metical', 'MZ'], ['NAD', 'Namibian Dollar', 'NA'], ['NPR', 'Nepalese Rupee', 'NP'],
      ['ANG', 'Netherlands Antillean Guilder', 'CW'], ['NZD', 'New Zealand Dollar', 'NZ'], ['NIO', 'Nicaraguan Córdoba', 'NI'], ['NGN', 'Nigerian Naira', 'NG'],
      ['NOK', 'Norwegian Krone', 'NO'], ['OMR', 'Omani Rial', 'OM'], ['PAB', 'Panamanian Balboa', 'PA'], ['PKR', 'Pakistani Rupee', 'PK'],
      ['PGK', 'Papua New Guinean Kina', 'PG'], ['PYG', 'Paraguayan Guarani', 'PY'], ['PEN', 'Peruvian Sol', 'PE'], ['PHP', 'Philippine Piso', 'PH'],
      ['PLN', 'Polish Zloty', 'PL'], ['QAR', 'Qatari Rial', 'QA'], ['RON', 'Romanian Leu', 'RO'], ['RUB', 'Russian Ruble', 'RU'],
      ['RWF', 'Rwandan Franc', 'RW'], ['WST', 'Samoan Tala', 'WS'], ['SHP', 'St. Helena Pound', 'SH'], ['SAR', 'Saudi Riyal', 'SA'],
      ['STD', 'São Tomé & Príncipe Dobra', 'ST'], ['RSD', 'Serbian Dinar', 'RS'], ['SCR', 'Seychellois Rupee', 'SC'], ['SLL', 'Sierra Leonean Leone', 'SL'],
      ['SGD', 'Singapore Dollar', 'SG'], ['SDG', 'Sudanese Pound', 'SD'], ['SYP', 'Syrian Pound', 'SY'], ['ZAR', 'South African Rand', 'ZA'],
      ['KRW', 'South Korean Won', 'KR'], ['SSP', 'South Sudanese Pound', 'SS'], ['SBD', 'Solomon Islands Dollar', 'SB'], ['LKR', 'Sri Lankan Rupee', 'LK'],
      ['SRD', 'Surinamese Dollar', 'SR'], ['SZL', 'Swazi Lilangeni', 'SZ'], ['SEK', 'Swedish Krona', 'SE'], ['CHF', 'Swiss Franc', 'CH'],
      ['TWD', 'New Taiwan Dollar', 'TW'], ['THB', 'Thai Baht', 'TH'], ['TJS', 'Tajikistani Somoni', 'TJ'], ['TZS', 'Tanzanian Shilling', 'TZ'],
      ['TOP', 'Tongan Paʻanga', 'TO'], ['TTD', 'Trinidad & Tobago Dollar', 'TT'], ['TND', 'Tunisian Dinar', 'TN'], ['TRY', 'Turkish Lira', 'TR'],
      ['TMT', 'Turkmenistani Manat', 'TM'], ['UGX', 'Ugandan Shilling', 'UG'], ['UAH', 'Ukrainian Hryvnia', 'UA'], ['AED', 'United Arab Emirates Dirham', 'AE'],
      ['UYU', 'Uruguayan Peso', 'UY'], ['UZS', 'Uzbekistani Som', 'UZ'], ['VUV', 'Vanuatu Vatu', 'VU'], ['VEF', 'Venezuelan Bolívar', 'VE'],
      ['VND', 'Vietnamese Dong', 'VN'], ['XOF', 'West African CFA Franc', 'SN'], ['YER', 'Yemeni Rial', 'YE'], ['ZMW', 'Zambian Kwacha', 'ZM'],
    ];

    var FX_TTL = 24 * 60 * 60 * 1000;
    var GEO_TTL = 24 * 60 * 60 * 1000;
    var STORAGE_SELECTED = 'ru-currency-selected';
    var STORAGE_RATES = 'ru-currency-rates';
    var STORAGE_GEO = 'ru-currency-geo';

    function flagMarkup(country) {
      if (!country) return '🌐';
      var cc = country.toLowerCase();
      return (
        '<img src="https://flagcdn.com/24x18/' + cc + '.png" ' +
        'srcset="https://flagcdn.com/48x36/' + cc + '.png 2x" ' +
        'width="18" height="14" alt="" loading="lazy">'
      );
    }

    function readJSON(key) {
      try {
        return JSON.parse(window.localStorage.getItem(key));
      } catch (err) {
        return null;
      }
    }

    function writeJSON(key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (err) {
        /* storage unavailable (private mode, quota) — degrade to session-only */
      }
    }

    function init() {
      var root = document.querySelector('[data-currency-widget]');
      if (!root) return;

      var shopCurrency = (root.dataset.shopCurrency || 'USD').toUpperCase();
      var autoLabel = root.dataset.labelAuto || 'Auto location';
      var toggle = root.querySelector('[data-currency-toggle]');
      var panel = root.querySelector('[data-currency-panel]');
      var list = root.querySelector('[data-currency-list]');
      var searchInput = root.querySelector('[data-currency-search]');
      var emptyState = root.querySelector('[data-currency-empty]');
      var flagEl = root.querySelector('[data-currency-flag]');
      var codeEl = root.querySelector('[data-currency-code]');
      var rates = null;
      var divider = null;

      function buildList() {
        var autoItem = document.createElement('li');
        autoItem.className = 'currency-widget__option';
        autoItem.setAttribute('role', 'option');
        autoItem.dataset.code = 'auto';
        autoItem.dataset.search = autoLabel.toLowerCase();
        autoItem.innerHTML =
          '<span class="currency-widget__option-flag" aria-hidden="true">🌐</span>' +
          '<span class="currency-widget__option-name">' + autoLabel + '</span>';
        list.appendChild(autoItem);

        divider = document.createElement('hr');
        divider.className = 'currency-widget__option-divider';
        list.appendChild(divider);

        CURRENCIES.forEach(function (entry) {
          var code = entry[0];
          var name = entry[1];
          var country = entry[2];
          var item = document.createElement('li');
          item.className = 'currency-widget__option';
          item.setAttribute('role', 'option');
          item.dataset.code = code;
          item.dataset.search = (name + ' ' + code).toLowerCase();
          item.innerHTML =
            '<span class="currency-widget__option-flag" aria-hidden="true">' + flagMarkup(country) + '</span>' +
            '<span class="currency-widget__option-name">' + name + ' (' + code + ')</span>';
          list.appendChild(item);
        });
      }

      function filterList(query) {
        var term = query.trim().toLowerCase();
        var matches = 0;

        list.querySelectorAll('[data-code]').forEach(function (option) {
          var isMatch = term === '' || option.dataset.search.indexOf(term) !== -1;
          option.hidden = !isMatch;
          if (isMatch) matches += 1;
        });

        divider.hidden = term !== '';
        emptyState.hidden = matches > 0;
      }

      function updateSelectedState(selected) {
        var options = list.querySelectorAll('[data-code]');
        options.forEach(function (option) {
          option.setAttribute('aria-selected', option.dataset.code === selected ? 'true' : 'false');
        });
      }

      function updateToggleDisplay(code) {
        var entry = CURRENCIES.find(function (c) { return c[0] === code; });
        flagEl.innerHTML = entry ? flagMarkup(entry[2]) : '🌐';
        codeEl.textContent = code;
      }

      function formatMoney(amountDecimal, code) {
        var rounded = Math.round(amountDecimal);
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: code,
            currencyDisplay: 'symbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(rounded);
        } catch (err) {
          return code + ' ' + rounded;
        }
      }

      function applyCurrency(code) {
        var priceEls = document.querySelectorAll('.js-price[data-price-cents]');

        priceEls.forEach(function (el) {
          if (!el.dataset.original) {
            el.dataset.original = el.textContent;
          }

          if (code === shopCurrency) {
            el.textContent = el.dataset.original;
            return;
          }

          if (!rates || !rates[code]) {
            el.textContent = el.dataset.original;
            return;
          }

          var cents = parseFloat(el.dataset.priceCents);
          if (isNaN(cents)) return;

          var converted = (cents / 100) * rates[code];
          el.textContent = formatMoney(converted, code);
        });
      }

      function loadRates() {
        var cached = readJSON(STORAGE_RATES);
        if (cached && cached.base === shopCurrency && Date.now() - cached.ts < FX_TTL) {
          rates = cached.rates;
          return Promise.resolve(rates);
        }

        return fetch('https://open.er-api.com/v6/latest/' + shopCurrency)
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data && data.result === 'success' && data.rates) {
              rates = data.rates;
              writeJSON(STORAGE_RATES, { base: shopCurrency, rates: rates, ts: Date.now() });
            }
            return rates;
          })
          .catch(function () {
            return null;
          });
      }

      function resolveGeoCurrency() {
        var cached = readJSON(STORAGE_GEO);
        if (cached && Date.now() - cached.ts < GEO_TTL) {
          return Promise.resolve(cached.code);
        }

        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = controller ? setTimeout(function () { controller.abort(); }, 3500) : null;

        return fetch('https://ipapi.co/json/', controller ? { signal: controller.signal } : undefined)
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var code = data && data.currency ? data.currency.toUpperCase() : shopCurrency;
            writeJSON(STORAGE_GEO, { code: code, ts: Date.now() });
            return code;
          })
          .catch(function () {
            return shopCurrency;
          })
          .finally(function () {
            if (timer) clearTimeout(timer);
          });
      }

      function selectCurrency(code, persist) {
        if (persist) {
          writeJSON(STORAGE_SELECTED, { code: code, ts: Date.now() });
        }

        if (code === 'auto') {
          updateSelectedState('auto');
          updateToggleDisplay(shopCurrency);
          resolveGeoCurrency().then(function (geoCode) {
            var stillAuto = readJSON(STORAGE_SELECTED);
            if (stillAuto && stillAuto.code !== 'auto') return;
            updateToggleDisplay(geoCode);
            loadRates().then(function () { applyCurrency(geoCode); });
          });
          applyCurrency(shopCurrency);
          return;
        }

        updateSelectedState(code);
        updateToggleDisplay(code);
        loadRates().then(function () { applyCurrency(code); });
      }

      function openList() {
        panel.hidden = false;
        root.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
        searchInput.focus();
      }

      function closeList() {
        panel.hidden = true;
        root.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
        filterList('');
      }

      var deferInit = window.requestIdleCallback || function (fn) { window.setTimeout(fn, 200); };

      buildList();

      toggle.addEventListener('click', function () {
        if (panel.hidden) {
          openList();
        } else {
          closeList();
        }
      });

      searchInput.addEventListener('input', function () {
        filterList(searchInput.value);
      });

      list.addEventListener('click', function (event) {
        var option = event.target.closest('[data-code]');
        if (!option) return;
        selectCurrency(option.dataset.code, true);
        closeList();
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closeList();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeList();
      });

      var stored = readJSON(STORAGE_SELECTED);
      deferInit(function () {
        selectCurrency(stored ? stored.code : 'auto', false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sectionRoots = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group)'
    );
    var targets = [];
    sectionRoots.forEach(function (root) {
      root.querySelectorAll('.section-container, .instagram-feed__heading, .instagram-feed__scroller').forEach(function (el) {
        targets.push(el);
      });
    });
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (target) {
        target.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (target) {
      target.classList.add('js-reveal');
      observer.observe(target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["splash-screen"] && !Shopify.designMode) return;
  try {
    (function () {
    var splash = document.getElementById('splash-screen');
    if (!splash) return;

    try {
      sessionStorage.setItem('ru-splash-shown', '1');
    } catch (e) {}

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function remove() {
      splash.remove();
      document.documentElement.classList.remove('splash-lock');
    }

    document.documentElement.classList.add('splash-lock');

    var holdTime = reducedMotion ? 200 : 700;

    window.setTimeout(function () {
      splash.classList.add('is-hidden');
      splash.addEventListener('transitionend', remove, { once: true });
    }, holdTime);
  })();
  } catch(e) { console.error(e); }
})();

})();
